import React, { Fragment } from 'react';
import { FiPlus } from 'react-icons/fi';
import CouponItem from './CouponItem';
import { Booklet, CompanyCategory } from '../../types/generated.types';
import { CouponWithCompany } from '../../context/BookletCouponsContext';

interface CouponItemsProps {
  selectedCoupons: (CouponWithCompany | null)[];
  onCouponSelect: (index: number) => void;
  onCouponRemove: (index: number) => void;
  bookletColor: string;
  startIndex?: number;
  companyCategories: CompanyCategory[];
  selectedBooklet?: Booklet | null;
}

const CouponItems: React.FC<CouponItemsProps> = ({
  selectedCoupons,
  onCouponSelect,
  onCouponRemove,
  bookletColor,
  startIndex = 0,
  companyCategories,
  selectedBooklet,
}) => {
  return (
    <Fragment>
      {selectedCoupons.map((coupon, localIndex) => {
        const actualIndex = startIndex + localIndex;
        return (
          <div key={actualIndex} className="coupon-item" onClick={() => !coupon && onCouponSelect(actualIndex)}>
            {coupon ? (
              <CouponItem
                index={actualIndex}
                coupon={coupon}
                onCouponRemove={onCouponRemove}
                bookletColor={bookletColor}
                companyCategories={companyCategories}
                selectedBooklet={selectedBooklet}
              />
            ) : (
              <div className="coupon-placeholder">
                <span className="plus-icon"><FiPlus size={24} /></span>
                <p>Lägg till kupong</p>
              </div>
            )}
          </div>
        );
      })}
    </Fragment>
  );
};

export default CouponItems;
